<template>
  <div>
    <div class="header">
      <div class="vphtitle">
        I-10 Calcasieu River Bridge Improvements Project
      </div>
      <div class="vphsubtitle">Open House Public Hearing - December 2022</div>
    </div>
    <div class="content">
      <Stations />
    </div>
  </div>
</template>

<script>
import Stations from "@/components/VPH/Stations.vue";

export default {
  components: { Stations }
};
</script>

<style>
.header {
  padding: 1em;
  color: #ffffff;
  background-color: #4d5357;
}

.vphtitle {
  display: block;
  font-size: 2em;
  margin-block-start: 0.67em;
  margin-block-end: 0.67em;
  margin-inline-start: 0px;
  margin-inline-end: 0px;
  font-weight: bold;
}

.vphsubtitle {
  display: block;
  font-size: 1.5em;
  margin-block-start: 0.83em;
  margin-block-end: 0.83em;
  margin-inline-start: 0px;
  margin-inline-end: 0px;
  font-weight: bold;
}

.content {
  margin-left: 10vw;
  margin-right: 10vw;
}

@media only screen and (max-width: 600px) {
  .header {
    padding: 0.5em;
  }

  .vphtitle {
    font-size: 1.25em;
  }

  .vphsubtitle {
    font-size: 1em;
  }
}
</style>
